import React, { useEffect, useState } from 'react'
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import backArrow from '../../../../_metronic/assets/images/svg/data-room/blue-back-arrow.svg'
import editspaceBG from '../../../../_metronic/assets/images/svg/data-room/space-bg-change-icon.svg'
import { EditSpaceBgDropdown } from '../components/EditSpaceBgDropdown'
import OutsideClickHandler from 'react-outside-click-handler'
import { AddContentDrawer } from '../components/data-room-drawer/AddContentDrawer'
import { Formik, ErrorMessage, Form } from 'formik'
import * as Yup from 'yup'
import { addContent, createDataRoom, getDataRoom, updateDataRoom } from '../core/_requests'
import { useIntl } from 'react-intl'
import { useAuth } from '../../auth'
import { toast } from 'react-toastify'
import { FileUpload } from '../../widgets/components/FileUpload'
import { DisplayBgImage } from '../../widgets/components/General/DisplayBgImage'
import { AddSpaceBgDropdown } from '../components/AddSpaceBgDropdown'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import { CustomButton } from '../../widgets/components/UI/CustomButton'
// import { roleValues } from '../../../core/_constants'
import { ShareDrawer } from '../components/data-room-drawer/ShareDrawer'
import { CreateLinkDrawer } from '../components/data-room-drawer/CreateLinkDrawer'
import { UploadDrawer } from '../components/data-room-drawer/UploadDrawer'
import { UploadOptionsDrawer } from '../components/data-room-drawer/UploadOptionsDrawer'
import { useMoveToFolderData } from '../core/FileToFolderAuth'
import { AddFolderModal } from './AddFolderModal'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'

function DataRoomSpaceEdit({ isHidden, isTrash }: { isHidden?: boolean; isTrash?: boolean }) {
  const { formatMessage } = useIntl()
  const [menuOpen, setMenuOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const { dataRoomId } = useParams()
  const { companyId, role, isFoldersPresent, setShowBillingModal, currentUser } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const location = useLocation()
  const pathname: boolean = location.pathname.includes('/create-data-room')
  const viewPathname: boolean = location.pathname.includes('/view-details')
  const navigate = useNavigate()
  const [imgName, setImgName] = useState<string | undefined>()
  const [addspaceBG, setAddSpaceBg] = useState<string | undefined>()
  const [singleDataRoom, setSingleDataRoom] = useState<any>({})
  const [singleDataRoomApiLoading, setSingledataRoomApiLoading] = useState(false)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const {
    dataRoomLatestBreadcrumbId,
    setShowAddContentDrawer,
    setFolderNameErr,
    setRefreshFuncBool,
    setRefreshFuncBoolAddToSpace,
    setCreatedFolderContentId,
  } = useMoveToFolderData()
  const { setShareDrawer } = useMoveToFolderData()
  const [folderContentIdDR, setFolderContentIdDR] = useState<any>(0)
  const [showCreateFolderModalDR, setShowCreateFolderModalDR] = useState(false)
  const [createLoadingDR, setCreateLoadingDR] = useState<boolean>(false)
  const [newFolderName, setNewFolderName] = useState<string>('')
  const [dataRoomUploadsFolderContentId, setDataRoomUploadsFolderContentId] = useState<number>(0)
  const [createdFolderParentId, setCreatedFolderParentId] = useState<any>(null)
  const [refreshFuncBoolCreateFolder, setRefreshFuncBoolCreateFolder] = useState<boolean>(false)
  const [createFolderBool, setCreateFolderBool] = useState<boolean>(false)
  const [hideButtonHiddenTrash, setHideButtonHiddenTrash] = useState<boolean>(false)
  const [showFileUpload, setShowFileUpload] = useState(false);
  // const [modelStatus, setModelStatus] = useState<boolean>(false)


  const handleOpenFileUpload = () => {
    setMenuOpen(false)
    setShowFileUpload(true);
    setModelStatus(true)
  };

  const createDataRoomSchema = Yup.object().shape({
    title: Yup.string().required(formatMessage({ id: '*Title is required' })),
  })

  const getDataRoomById = async () => {
    try {
      setSingledataRoomApiLoading(true)
      // if (
      //   companyId &&
      //   dataRoomId &&
      //   role &&
      //   role !== roleValues.BILLING &&
      //   role !== roleValues.CURATOR
      // ) {
        if (
          companyId &&
          dataRoomId
        ) {
        const {
          data: { data, success, errors },
        } = await getDataRoom(parseInt(dataRoomId))
        if (success) {
          setSingleDataRoom(data)
          setImgName(data?.dataRoomLogo?.name)
          setAddSpaceBg(data?.dataRoomBanner?.name)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSingledataRoomApiLoading(false)
    }
  }

  useEffect(() => {
    getDataRoomById()
  }, [dataRoomId, role]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleOpen = () => {
    setModelStatus(true)
  }
  const handleClose = () => {
    setModelStatus(false)
  }

  enum Status {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT',
  }

  const initialValues = {
    title: singleDataRoom?.title || '',
    subtitle: singleDataRoom?.subtitle || '',
    logoId: singleDataRoom?.logoId || null,
    bannerId: singleDataRoom?.bannerId || null,
    status: singleDataRoom?.status || Status.DRAFT,
  }

  const onSubmit = async (values: any, { resetForm }: any) => {
    try {
      setLoading(true)
      if (dataRoomId) {
        const {
          data: { success, errors },
        } = await updateDataRoom(values, +dataRoomId)
        if (success) {
          toast.success(formatMessage({ id: 'Data Room updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateDataRoomSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_id: dataRoomId,
                status: values.status,
                title: values.title,
              },
            },
          })
          navigate('/data-rooms/spaces')
        } else {
          setLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateDataRoomFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                dataroom_id: dataRoomId,
                status: values.status,
                title: values.title,
                error: errors[0],
              },
            },
          })
        }
      } else {
        if (values.bannerId === null) {
          delete values.bannerId
        }
        if (companyId) {
          const {
            data: { success, errors },
          } = await createDataRoom({ ...values, companyId: +companyId })
          if (success) {
            resetForm()
            setImgName('')
            setAddSpaceBg('')
            toast.success(formatMessage({ id: 'Data Room Created successfully' }))
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CreateDataRoomSuccessful,
                action: 'normal',
                metadata: {
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  status: values.status,
                  title: values.title,
                },
              },
            })
            navigate('/data-rooms/spaces')
          } else {
            resetForm()
            setImgName('')
            setShowBillingModal(true)
            errors.forEach((error: string) => {
              toast.error(formatMessage({ id: error }), { autoClose: false })
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CreateDataRoomFailed,
                action: 'normal',
                metadata: {
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  status: values.status,
                  title: values.title,
                  error: errors[0],
                },
              },
            })
          }
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const handleAddFilesClick = () => {
    setShowAddContentDrawer(true)
  }
  const handleCreateFolderClickDR = (id: any) => {
    if (id) {
      setFolderContentIdDR(dataRoomUploadsFolderContentId)
      setShowCreateFolderModalDR(true)
      setCreateFolderBool(true)
    } else {
      setFolderContentIdDR(dataRoomUploadsFolderContentId)
      setShowCreateFolderModalDR(true)
      setCreateFolderBool(true)
    }
  }
  useEffect(() => {
    setCreatedFolderParentId(dataRoomLatestBreadcrumbId)
  }, [dataRoomLatestBreadcrumbId]) // eslint-disable-line

  const handleCreateFolderDataRoom = async (
    type: string,
    companyId: number,
    newName: string,
    parentId: string
  ) => {
    if (!newName) {
      setFolderNameErr(true)
      return
    }
    try {
      setCreateLoadingDR(true)
      if (companyId) {
        const {
          data: { data, success, errors },
        } = await addContent(type, companyId, newName, parentId)
        if (success) {
          if (createdFolderParentId) {
            setCreatedFolderContentId(data?.contentId)
            setRefreshFuncBoolCreateFolder(true)
            setShowCreateFolderModalDR(false)
            toast.success(formatMessage({ id: 'Folder created successfully' }))
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.DataRoomAddFolderSuccessful,
                action: 'normal',
                metadata: {
                  type,
                  company_id: companyId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  new_name: newName,
                  parent_id: parentId,
                },
              },
            })
            setNewFolderName('')
            setRefreshFuncBool(true)
          } else {
            setCreatedFolderContentId(data?.contentId)
            setRefreshFuncBoolAddToSpace(true)
            setShowCreateFolderModalDR(false)
            toast.success(formatMessage({ id: 'Folder created successfully' }))
            setNewFolderName('')
            setRefreshFuncBool(true)
          }
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DataRoomAddFolderFailed,
              action: 'normal',
              metadata: {
                type,
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                new_name: newName,
                parent_id: parentId,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setCreateLoadingDR(false)
    }
  }

  useEffect(() => {
    setHideButtonHiddenTrash(
      location.pathname.includes('hidden') || location.pathname.includes('trash')
    )
  }, [location.pathname])

  return (
    <>
      <div className='data-room-space-edit-wrapper'>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={createDataRoomSchema}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {(formik) => {
              return (
                <>
                  {singleDataRoomApiLoading ? <div /> : null}
                  <Form onSubmit={formik.handleSubmit}>
                    <div className='Page_ToolBar-wrapper d-md-flex flex-row align-items-center justify-content-between'>
                      <div className='Page_ToolBar-left'>
                        {viewPathname ? (
                          <h5 className='mb-0 text-dark'>
                            {formatMessage({ id: 'View Data Room' })}
                          </h5>
                        ) : !pathname ? (
                          <h5 className='mb-0 text-dark'>
                            {formatMessage({ id: 'Edit Data Room' })}
                          </h5>
                        ) : (
                          <h5 className='mb-0 text-dark'>
                            {formatMessage({ id: 'Create Data Room' })}
                          </h5>
                        )}
                        <ul className='breadcrumb breadcrumb-line text-muted fs-6 fw-bold mt-3'>
                          <li className='breadcrumb-item pe-3'>
                            <Link
                              to={`/data-rooms/spaces`}
                              className='pe-3 item_link d-flex align-items-center'
                            >
                              <img src={backArrow} className='me-2' alt=''></img>{' '}
                              {formatMessage({ id: 'Go Back' })}
                            </Link>
                          </li>
                        </ul>
                      </div>
                      <div className='Page_ToolBar-right d-flex flex-row align-items-center justify-content-end gap-2 flex-wrap'>
                        {viewPathname && singleDataRoom.status === 'PUBLISHED' && (
                          <button
                            type='button'
                            onClick={() => {
                              setShareDrawer(true)
                            }}
                            className='btn btn-light-primary flex-grow-1'
                          >
                            {formatMessage({ id: 'Share' })}
                          </button>
                        )}

                        {!viewPathname && (
                          <CustomButton
                            isSubmitting={formik.isSubmitting}
                            isValid={formik.isValid}
                            buttonText={formatMessage({ id: 'Save Changes' })}
                            loading={loading}
                            widthLoading={2}
                            width={2}
                            margin={'mt-5'}
                            buttonColor='bg-primary text-white'
                          />
                        )}
                      </div>
                    </div>
                    <div
                      className='space-edit-head-wrapper'
                      style={{ backgroundImage: `url(${addspaceBG})`, backdropFilter: 'invert(1)' }}
                    >
                      <div className='overlay'></div>
                      {!pathname ? (
                        <>
                          <div className=''>
                            <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                              {!viewPathname && (
                                <button
                                  type='button'
                                  className='btn btn-sm edit-space-bg bg-white d-flex align-items-center justify-content-center '
                                  onClick={() => setMenuOpen(!menuOpen)}
                                >
                                  <img src={editspaceBG} alt=''></img>
                                </button>
                              )}

                              <DisplayBgImage
                                imgName={addspaceBG}
                                width='100%'
                                height='240'
                                fit='cover'
                                alt='editBackgroundImage'
                                className='opacity-50'
                              />
                              <EditSpaceBgDropdown
                                isOpen={menuOpen}
                                formik={formik}
                                setSpaceBG={setAddSpaceBg}
                                setDeleteShowModal={setDeleteShowModal}
                                showDeleteModal={showDeleteModal}
                                dataRoomId={dataRoomId}
                                setMenuOpen={setMenuOpen}
                                handleOpenFileUpload={handleOpenFileUpload}
                              />
                            </OutsideClickHandler>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className=''>
                            <OutsideClickHandler onOutsideClick={() => setMenuOpen(false)}>
                              <button
                                type='button'
                                className='btn btn-sm edit-space-bg bg-white d-flex align-items-center justify-content-center '
                                onClick={() => setMenuOpen(!menuOpen)}
                              >
                                <img src={editspaceBG} alt=''></img>
                              </button>
                              <DisplayBgImage
                                imgName={addspaceBG}
                                width='100%'
                                fit='cover'
                                alt={formatMessage({ id: 'addBackgroundImage' })}
                              />
                              <AddSpaceBgDropdown
                                isOpen={menuOpen}
                                formik={formik}
                                setSpaceBG={setAddSpaceBg}
                                setDeleteShowModal={setDeleteShowModal}
                                showDeleteModal={showDeleteModal}
                                setMenuOpen={setMenuOpen}
                              />
                            </OutsideClickHandler>
                          </div>
                        </>
                      )}

                      <div className='space-edit-head-form d-flex flex-column flex-md-row gap-4 px-8'>
                        <div className='space-profile-image-wrapper'>
                          {/* {!pathname && !viewPathname ? (
                            <p className='text-white mb-0 dark_text_color'>
                              {formatMessage({ id: 'Edit Image' })}
                            </p>
                          ) : !viewPathname ? (
                            <p className='text-white mb-0 dark_text_color'>
                              {formatMessage({ id: 'Add Image' })}
                            </p>
                          ) : null} */}

                          <div className=''>
                            {singleDataRoomApiLoading ? (
                              <>
                                <Skeleton
                                  width={134}
                                  height={134}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </>
                            ) : (
                              <>
                                <DisplayImage
                                  imgName={imgName}
                                  width='134'
                                  height='134'
                                  fit='contain'
                                  className='rounded-2'
                                  alt={formatMessage({ id: 'profile' })}
                                />
                                {!viewPathname && (
                                  <div className='position-absolute' style={{ top: '-10px', left: '140px' }}>
                                    <div onClick={handleOpen}>
                                      <button
                                        type='button'
                                        className='btn btn-sm edit-space-profile-image bg-white d-flex align-items-center justify-content-center rounded-circle p-1'
                                      >
                                        <img
                                          src={editspaceBG}
                                          alt={formatMessage({ id: 'edit-profile-pencil' })}
                                        />
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>

                        </div>

                        {singleDataRoomApiLoading ? (
                          <div className='space-title-n-description-wrapper gap-4 flex-grow-1'>
                            <Skeleton
                              height={44}
                              style={{ marginBottom: '8px' }}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                            <Skeleton
                              height={74}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          </div>
                        ) : (
                          <div className='space-title-n-description-wrapper flex-grow-1'>
                            <input
                              type='text'
                              className='form-control form-control-white'
                              name='title'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.title}
                              disabled={viewPathname}
                              placeholder={formatMessage({ id: 'Enter Title for the space' })}
                            />
                            <ErrorMessage
                              name='title'
                              component='div'
                              className='error-message text-warning'
                            />
                            <textarea
                              className='form-control form-control-white '
                              rows={3}
                              name='subtitle'
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.subtitle}
                              data-kt-element='input'
                              disabled={viewPathname}
                              placeholder={formatMessage({ id: 'Add Subtitle ' })}
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </Form>

                  <FileUpload
                    fileSize={2097152}
                    maxFileNumber={1}
                    allowType={['image/*', '.jpg', '.jpeg', '.png']}
                    metaData={{ module: 'logo', isProtected: false, isDataRooms: true }}
                    modalStatus={modelStatus}
                    handleClose={handleClose}
                    handleSuccess={(id: number, name: string) => {
                      setImgName(name)
                      formik.setFieldValue('logoId', id)
                    }}
                    showCompatibilityMsg={false}
                    resourceType='all'
                  />
                  {showFileUpload && <FileUpload
                    fileSize={2097152}
                    maxFileNumber={1}
                    allowType={['image/*', '.jpg', '.jpeg', '.png']}
                    metaData={{ module: 'logo', isProtected: false }}
                    modalStatus={modelStatus}
                    handleClose={handleClose}
                    handleSuccess={(id: number, name: string) => {
                      setAddSpaceBg(name)
                      formik.setFieldValue('bannerId', id);
                      setShowFileUpload(false);
                    }}
                    showCompatibilityMsg={false}
                    resourceType='all'
                  />}
                </>
              )
            }}

          </Formik>
        </div>

        {pathname ? null : (
          <div className='space-edit-body-wrapper bg-white'>
            <div className='space-file-manager-top d-flex flex-md-row flex-column-reverse align-items-md-end justify-content-between dark-border'>
              <div className='space-file-manager-top-left'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5  flex-nowrap '>
                  <li className='nav-item mobile-tab font-size-13'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 text-dark ` +
                        (location.pathname.includes('all-files') && 'active')
                      }
                      to={`/data-rooms/${location.pathname.includes('/view-details/')
                        ? 'view-details/'
                        : 'space-edit/'
                        }all-files/${dataRoomId}`}
                    >
                      {formatMessage({ id: 'All files' })}
                    </Link>
                  </li>
                  <li className='nav-item mobile-tab font-size-13'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 text-dark ` +
                        (location.pathname.includes('hidden') && 'active')
                      }
                      to={`/data-rooms/${location.pathname.includes('/view-details/')
                        ? 'view-details/'
                        : 'space-edit/'
                        }hidden/${dataRoomId}`}
                    >
                      {formatMessage({ id: 'Hidden' })}
                    </Link>
                  </li>
                  <li className='nav-item mobile-tab font-size-13'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 text-dark ` +
                        (location.pathname.includes('trash') && 'active')
                      }
                      to={`/data-rooms/${location.pathname.includes('/view-details/')
                        ? 'view-details/'
                        : 'space-edit/'
                        }trash/${dataRoomId}`}
                    >
                      {formatMessage({ id: 'Trash' })}
                    </Link>
                  </li>
                </ul>
              </div>
              {hideButtonHiddenTrash ? null : (
                <div className='space-file-manager-top-right d-flex align-items-center justify-content-end'>
                  <button
                    className='btn bg-primary custom-button-property text-white flex-grow-1 font-size-13 '
                    onClick={() => {
                      handleCreateFolderClickDR(dataRoomLatestBreadcrumbId)
                    }}
                  >
                    {formatMessage({ id: 'Add Folder' })}
                  </button>
                  {isFoldersPresent?.length > 0 && (
                    <button
                      className='btn btn-bg-primary text-white flex-grow-1 font-size-13 '
                      onClick={handleAddFilesClick}
                    >
                      {formatMessage({ id: 'Add Files' })}
                    </button>
                  )}
                </div>
              )}
            </div>
            <Outlet />
          </div>
        )}
        <ShareDrawer dataRoomId={dataRoomId} />
        <CreateLinkDrawer dataRoomId={dataRoomId} />

        <AddContentDrawer
          dataRoomId={dataRoomId}
          setDataRoomUploadsFolderContentId={setDataRoomUploadsFolderContentId}
          createdFolderParentId={createdFolderParentId}
          refreshFuncBoolCreateFolder={refreshFuncBoolCreateFolder}
          setRefreshFuncBoolCreateFolder={setRefreshFuncBoolCreateFolder}
          createFolderBool={createFolderBool}
          setCreateFolderBool={setCreateFolderBool}
        />
        <UploadDrawer />
        <UploadOptionsDrawer DrClick={true} dataRoomId={dataRoomId} />
        <AddFolderModal
          renameFolderModal={showCreateFolderModalDR}
          setRenameFolderModal={setShowCreateFolderModalDR}
          onFolderRename={handleCreateFolderDataRoom}
          renameLoading={createLoadingDR}
          folderRenameId={companyId}
          newName={newFolderName}
          setNewName={setNewFolderName}
          heading={formatMessage({ id: 'Create' })}
          labelText={formatMessage({ id: 'Please type the name of your folder' })}
          btnText={formatMessage({ id: 'Create Folder' })}
          showBool={true}
          folderParentId={folderContentIdDR}
        />
      </div>
    </>
  )
}

export default DataRoomSpaceEdit
